export default __webpack_public_path__ + "static/media/0029.f9e3f992.png";